
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/DashboardPie/DashboardPie.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./DashboardPie.html');
        
        var script = require('./DashboardPie.ts').default;
        module.exports = require('./DashboardPie.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    